import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { push } from 'react-router-redux';
import { AnyAction } from 'redux';
import { ModalWrapper } from '@shared/ui-components';

import { KreoDialogActions } from 'common/UIKit';
import { DialogWrapper } from 'common/UIKit/dialogs/dialog-wrapper';
import { SubscriptionEditor } from './subscription-editor';

export const SUBSCRIPTION__DIALOG = 'SUBSCRIPTION__DIALOG';


interface Props {
  closeDialog: () => void;
  redirectTo: (path: string) => void;
}

interface OwnState {
  teamSize: number;
}

class SubscriptionDialogComponent extends React.Component<Props, OwnState> {
  constructor(props: Props) {
    super(props);
    this.state = { teamSize: 1 };
  }

  public render(): JSX.Element {
    return (
      <DialogWrapper name={SUBSCRIPTION__DIALOG}>
        <ModalWrapper onExit={this.close}>
          <SubscriptionEditor
            mode='seats manage'
            onSubscriptionUpdate={this.close}
            onSubscriptionCancel={this.close}
          />
        </ModalWrapper>
      </DialogWrapper>
    );
  }

  @autobind
  private close(): void {
    this.props.closeDialog();
  }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): Props {
  return {
    redirectTo: path => dispatch(push(path)),
    closeDialog: () => dispatch(KreoDialogActions.closeDialog(SUBSCRIPTION__DIALOG)),
  };
}

const connector = connect(null, mapDispatchToProps);
export const SubscriptionDialog = connector(SubscriptionDialogComponent);
